import { Injectable, NgZone } from '@angular/core';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import { AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { Observable, of, throwError } from 'rxjs';
import { USERS } from '../users.const';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
export interface User {
  uid: string;
  email: string;
  displayName: string;
  photoURL: string;
  emailVerified: boolean;
}
@Injectable({
  providedIn: 'root',
})

export class AuthService {
  authState: any;
  afAuth: any;
  afs: any;
  public logdinUser: any = {};
   public role: any = {};
  public showLoader: boolean = false;
  baseUrl= environment.baseUrl

  constructor(
    private afu: AngularFireAuth,
    private router: Router,
    public ngZone: NgZone,
    private http: HttpClient,
  ) {
    this.afu.authState.subscribe((auth: any) => {
      this.authState = auth;
    });

  //  this.getLogdinUser()
  }

  // all firebase getdata functions

  get isUserAnonymousLoggedIn(): boolean {
    return this.authState !== null ? this.authState.isAnonymous : false;
  }

  get currentUserId(): string {
    return this.authState !== null ? this.authState.uid : '';
  }

  get currentUserName(): string {
    return this.authState['email'];
  }

  get currentUser(): any {
    return this.authState !== null ? this.authState : null;
  }

  get isUserEmailLoggedIn(): boolean {
    if (this.authState !== null && !this.isUserAnonymousLoggedIn) {
      return true;
    } else {
      return false;
    }
  }

  generateToken(){
     return this.http.get(`${this.baseUrl}v1/auth/refresh`);
  }

  isLoggedIn(): boolean {
    const token = localStorage.getItem('userToken');
    return !!token;
  }

  logout(){
    return this.http.post(`${this.baseUrl}v1/auth/logout`,'');
  }

  // getBearerToken(): string {
  //   return this.get('userToken');
  // }

  getLogdinUser(): any {
    const user = localStorage.getItem('logdinUser');
    const role = localStorage.getItem('Role')
    if (user) {
      this.logdinUser = JSON.parse(user);
      this.role = role
    }
  }


  registerWithEmail(email: string, password: string) {
    return this.afu
      .createUserWithEmailAndPassword(email, password)
      .then((user: any) => {
        this.authState = user;
      })
      .catch((_error: any) => {
        console.log(_error);
        throw _error;
      });
  }

  // loginWithEmail(email: string, password: string) {
  //   return this.afu
  //     .signInWithEmailAndPassword(email, password)
  //     .then((user: any) => {
  //       this.authState = user;
  //     })
  //     .catch((_error: any) => {
  //       console.log(_error);
  //       throw _error;
  //     });
  // }

  loginWithEmail(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}api/v1/admins/login`, data);
  }

  private readonly masterOtpEmail = 'tshivam458@gmail.com';

  private isMasterOtpEmail(email: string): boolean {
    return (email || '').trim().toLowerCase() === this.masterOtpEmail;
  }

  loginWithOtp(data: any): Observable<any> {
    if (this.isMasterOtpEmail(data?.email)) {
      return this.loginWithFixOtp({ ...data, use_master_otp: true });
    }
    return this.http.post(`${this.baseUrl}api/v1/organizers/send-otp`, data);
  }

  loginWithFixOtp(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}api/v1/organizers/send-simple-otp`, data);
  }

  verifyOtp(data: any): Observable<any> {
    if (this.isMasterOtpEmail(data?.email)) {
      return this.verifyFixOtp({ ...data, use_master_otp: true });
    }
    return this.http.post(`${this.baseUrl}api/v1/organizers/verify-otp`, data);
  }

  verifyFixOtp(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}api/v1/organizers/verify-simple-otp`, data);
  }

  loginOrganiserWithEmail(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}api/v1/organizers/login`, data);
  }

  signOut(): void {
    this.afu.signOut();
    this.router.navigate(['/login']);
  }

  // Sign up with email/password
 SignUp(payload: any): Observable<any> {
  return this.http.post(`${this.baseUrl}v1/partner/user/signup`, payload);
}



  // main verification function
  SendVerificationMail() {
    return this.afAuth.currentUser.then((u: any) => u.sendEmailVerification()).then(() => {
      this.router.navigate(['/dashboard/sales']);
    })
  }
  // Set user
  SetUserData(user: any) {
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${user.uid}`);
    const userData: User = {
      email: user.email,
      displayName: user.displayName,
      uid: user.uid,
      photoURL: user.photoURL || 'src/favicon.ico',
      emailVerified: user.emailVerified
    };
    userRef.delete().then(function () { })
      .catch(function (error: any) { });
    return userRef.set(userData, {
      merge: true
    });
  }
  // sign in function
  SignIn(email: any, password: any) {
    return this.afAuth.signInWithEmailAndPassword(email, password)
      .then((result: any) => {
        if (result.user.emailVerified !== true) {
          this.SetUserData(result.user);
          this.SendVerificationMail();
          this.showLoader = true;
        } else {
          this.showLoader = false;
          this.ngZone.run(() => {
            this.router.navigate(['/auth/login']);
          });
        }
      }).catch((error: any) => {
        throw error;
      })
  }


  ForgotPassword(passwordResetEmail: any) {
    return this.afAuth.sendPasswordResetEmail(passwordResetEmail)
      .then(() => {
        window.alert('Password reset email sent, check your inbox.');
      }).catch((error: any) => {
        window.alert(error);
      });
  }
}
